export const APP_NAME = process.env.VUE_APP_NAME || ''
export const APP_VERSION = process.env.VUE_APP_VERSION || ''
export const APP_DEFAULT_LANG = process.env.VUE_APP_DEFAULT_LANG || ''
export const DASHBOARD_URL_CONFIG_FILE = process.env.VUE_APP_DASHBOARD_URL_CONFIG_FILE || ''
export const APP_VIEWS_CONFIG_PATH = process.env.VUE_APP_VIEWS_CONFIG_PATH || ''
export const APP_CONNECTION_CONFIG_FILE = process.env.VUE_APP_CONNECTION_CONFIG_FILE || ''

export const APP_DEFAULT_LANGUAGES = process.env.VUE_APP_DEFAULT_LANGUAGES || []
export const APP_I18N_FILE = process.env.VUE_APP_I18N_FILE || ''
export const APP_EXTERNAL_COMPONENT_FILE = process.env.VUE_APP_EXTERNAL_COMPONENT_FILE || ''
export const APP_TIME_BASE_TO_STOP_LOADING = process.env.VUE_APP_TIME_BASE_TO_STOP_LOADING || ''
export const APP_LOADING_IMAGE = process.env.VUE_APP_LOADING_IMAGE || ''
export const APP_ERROR_IMAGE = process.env.VUE_APP_ERROR_IMAGE || ''
export const APP_VALIDATING_UPDATING_OBJECT = process.env.VUE_APP_VALIDATING_UPDATING_OBJECT || true
export const APP_LICENSE_FILE = process.env.VUE_APP_LICENSE_FILE || ''
export const APP_NOTIFICATION_TIME = process.env.VUE_APP_NOTIFICATION_TIME || 10000
export const APP_REDIRECT_ON_LOGIN = process.env.VUE_APP_REDIRECT_ON_LOGIN || 'index'
